// src/lib/config.ts

/**
 * Centralized configuration management
 */
export const CONFIG = {
  /**
   * Get the current site URL based on environment
   */
  get siteUrl(): string {
    return import.meta.env.VITE_SITE_URL || 'http://localhost:5173';
  },

  /**
   * Generate a fully qualified URL
   * @param path Relative path (should start without a slash)
   * @returns Complete URL
   */
  url(path: string): string {
    // Ensure path doesn't start with a slash
    const cleanPath = path.replace(/^\//, '');
    return `${this.siteUrl}/${cleanPath}`;
  },

  /**
   * Check if current environment is production
   */
  get isProduction(): boolean {
    return import.meta.env.PROD;
  },

  /**
   * Check if current environment is development
   */
  get isDevelopment(): boolean {
    return import.meta.env.DEV;
  },
};
